// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Switch_tabsContainer__BEs07","switchTab":"Switch_switchTab__sJ994","active":"Switch_active__xDJG3"};